import config from "../../utils/config";
import common from "../../utils/common";

const Customer = function (obj) {
    this._init_(obj);
};
Customer.prototype = {
    constructor: Customer,
    _init_: function (obj) {
        this.customerId = obj.customerId;
        this.customerChannelId = obj.customerChannelId;
        this.robotInitInfo = (obj.robotInitInfo!=null&&obj.robotInitInfo!=undefined?obj.robotInitInfo:'');
        this.customerCode =  (obj.customerCode!=null&&obj.customerCode!=undefined?obj.customerCode:'');
        this.companyId = obj.companyId;
        this.nickName =  (obj.nickName!=null&&obj.nickName!=undefined?obj.nickName:'');
        this.name =  (obj.name!=null&&obj.name!=undefined?obj.name:'');
        this.tel =  (obj.tel!=null&&obj.tel!=undefined?obj.tel:'');
        this.email =  (obj.email!=null&&obj.email!=undefined?obj.email:'');
        this.level =  (obj.level!=null&&obj.level!=undefined?obj.level:'');
        this.avatar =  (obj.avatar!=null&&obj.avatar!=undefined?obj.avatar:'');
        this.provinceCode =  (obj.provinceCode!=null&&obj.provinceCode!=undefined?obj.provinceCode:'');
        this.cityCode =  (obj.cityCode!=null&&obj.cityCode!=undefined?obj.cityCode:'');
        this.address =  (obj.address!=null&&obj.address!=undefined?obj.address:'');
        this.wxNumber =  (obj.wxNumber!=null&&obj.wxNumber!=undefined?obj.wxNumber:'');
        this.remark = (obj.remark!=null&&obj.remark!=undefined?obj.remark:'');
        this.sourceTerminal = config.sourceTerminal;
        this.sourceTerminalInfo = this.getOS()+this.Browse();
        this.serverName=""
        this.sourceIp=''
        this.sourceProvince=='';
        this.sourceCity='';
        this.sourceChannelId = obj.sourceChannelId;
        this.thirdId = obj.thirdId;
    },
    refreshSessionInfo: function (obj) {
        if (obj) {
            this.customerId = obj.customerId!=null&&obj.customerId!=undefined?obj.customerId:'';
            this.customerChannelId = obj.customerChannelId!=null&&obj.customerChannelId!=undefined?obj.customerChannelId:'';
            this.customerCode = obj.customerNo!=null&&obj.customerNo!=undefined?obj.customerNo:'';
            this.companyId =  obj.companyId!=null&&obj.companyId!=undefined?obj.companyId:'';
            this.avatar =  obj.customerAvatar!=null&&obj.customerAvatar!=undefined?obj.customerAvatar:'';
            if(obj.customerNickname!=null&&typeof obj.customerNickname !== 'undefined'){
                this.nickName =obj.customerNickname
            }
            this.tel = obj.customerTel!=null&&obj.customerTel!=undefined?obj.customerTel:'';
            this.email = obj.customerEmail!=null&&obj.customerEmail!=undefined?obj.customerEmail:'';
            this.sourceProvince = obj.sourceProvince!=null&&obj.sourceProvince!=undefined?obj.sourceProvince:'';
            this.sourceCity = obj.sourceCity!=null&&obj.sourceCity!=undefined?obj.sourceCity:'';
        }
    },
    setSourceIp: function (sourceIp) {
        this.sourceIp =sourceIp;
    },
    getCustomer: function () {
        var info = {
            customerId : this.customerId,
            customerChannelId : this.customerChannelId,
            customerCode : this.customerCode,
            companyId : this.companyId,
            nickName :  this.nickName,
            name :  this.name,
            tel :  this.tel,
            email :  this.email,
            level :  this.level,
            avatar :  this.avatar,
            provinceCode : this.provinceCode,
            cityCode : this.cityCode,
            address :  this.address,
            wxNumber :  this.wxNumber,
            remark :  this.remark,
            serverName :  this.serverName,
            sourceIp :  this.sourceIp,
            terminal :  config.sourceTerminal,
            terminalInfo :  this.sourceTerminalInfo,
            sourceChannelId :  this.sourceChannelId,
            thirdId :  this.thirdId
        };
        return info
    },
    toString: function () {
        return JSON.stringify(this);
    },
    /**获得操作系统***/
    getOS :function() {
        var sUserAgent = navigator.userAgent;
        if (common.isIOS()) {
            return "IOS端";
        }else if (common.isAndroid()) {
            return "Android端";
        }else {
            var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
            var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
            if (isMac) return "Mac";
            var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
            if (isUnix) return "Unix";
            var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
            if (isLinux) return "Linux";
            if (isWin) {
                var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
                if (isWin2K) return "Windows 2000";
                var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
                if (isWinXP) return "Windows XP";
                var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
                if (isWin2003) return "Windows 2003";
                var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
                if (isWinVista) return "Windows Vista";
                var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
                if (isWin7) return "Windows 7";
                var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
                if (isWin10) return "Windows 10";
            }
            return "other";
        }
    },
    /**获得浏览器***/
    Browse:function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
        var isIE = userAgent.indexOf("compatible") > -1
            && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
        var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
        var isSafari = userAgent.indexOf("Safari") > -1
            && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
        var isChrome = userAgent.indexOf("Chrome") > -1
            && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
        var kind="";
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                kind= "IE7";
            } else if (fIEVersion == 8) {
                kind= "IE8";
            } else if (fIEVersion == 9) {
                kind= "IE9";
            } else if (fIEVersion == 10) {
                kind= "IE10";
            }  else {
                kind= "IE";
            }
        }else if (isIE11) {
            kind="IE11";
        }else if (isOpera) {
            kind="Opera";
        }else if (isEdge) {
            kind="Edge";
        }else if (isFF) {
            kind="FF";
        }else if (isSafari) {
            kind="Safari";
        }else if (isChrome) {
            kind= "Chrome";
        }else if(common.isWx()){
            kind='微信';
        }else if(common.isComWx()){
            kind='企业微信';
        }else {
            kind='未知浏览器';
        }
        return '-'+kind;
    },
};
export default Customer;
